"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnSiteAppointment = void 0;
class OnSiteAppointment {
    constructor(props) {
        this.assignation_id = props?.assignation_id;
        this.cm = props?.cm || null;
        this.country = props?.country || null;
        this.cuit = props?.cuit || null;
        this.date = props?.date || null;
        this.datetime = props?.datetime || null;
        this.especialidad = props?.especialidad || null;
        this.fullname = props?.fullname || null;
        this.max_appointments = props?.max_appointments || 1;
        this.path_profile_pic = props?.path_profile_pic || null;
        this.patient = props?.patient || {};
        this.ref = props?.ref || null;
        this.slots = props?.slots || null;
        this.social_work = props?.social_work || [];
        this.state = props?.state || "ASSIGN";
        this.time = props?.time || null;
        this.timestamps = props?.timestamps || {};
        this.uid = props?.uid;
        // optionals
        this.adminActions = props?.adminActions || null;
        this.destino_final = props?.destino_final || null;
        this.overbooked = props?.overbooked || false;
        this.paid = props?.paid || false;
        this.payment_data = props?.payment_data || null;
        this.practices = props?.practices;
        this.price = props?.price || "0";
        this.scheduleId = props?.scheduleId;
        this.service = props?.service;
        this.shiftId = props?.shiftId;
        this.slot = props?.slot;
        this.observation = props?.observation || null;
        this.cancelMotive = props?.cancelMotive || "";
        this.appointment_data = props?.appointment_data || { motivos_de_consulta: "" };
    }
}
exports.OnSiteAppointment = OnSiteAppointment;
